import React, { useEffect, useState } from "react";
import { storyblokEditable } from "@storyblok/react";
import Script from "next/script";

const Contact = ({ blok }) => {
  const [successBox, setSuccessBox] = useState("none");

  const createFormCT = () => {
    Formio.createForm(
      document.getElementById("contactForm"),
      "https://forms.erfolgreichgastro.de/#/form/63e66dd816056f5e5acb420b/",{
        hooks: {
          customValidation: async (submission, next) => {
              const submissionData = JSON.stringify(submission.data);

              if (submissionData.includes("<") || submissionData.includes(">")) {
                console.error('Fehler beim Validieren des Formulars auf dem Server.');
                alert('Folgende Zeichen sind nicht erlaubt: <, >');
              }else{
                next();
              }
          }
      }
      }
    ).then(function (form) {
      form.on("render", function () {
        const selectField = form.getComponent(
          "chooseContactPartner"
        );
        const selectFieldLabel = document.querySelector('.col-form-label');

        if (
          window.location ==
            "https://hpew.datenwerk.dev/contact-stern-der-gastlichkeit/" ||
          window.location ==
            "http://localhost:3000/contact-stern-der-gastlichkeit/" 
            ||
          window.location ==
            "https://www.erfolgreichgastro.de/contact-stern-der-gastlichkeit/"
        ) {
          selectFieldLabel.style.display = 'none';
          selectField.setValue("Stern der Gastlichkeit");
          selectField.disabled = true;
        }
      });

      form.on("submit", function (submission) {
        showSuccessBox();
      });
    });
  };

  /*   useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.form.io/formiojs/formio.form.min.js";
    script.onload = createFormCT;
    document.body.appendChild(script);
  }, []); */

  useEffect(() => {
    createFormCT();
  }, []);

  function showSuccessBox() {
    setSuccessBox("flex");
  }

  function newSubmit() {
    location.reload();
  }

  return (
    <div className="contact-wrap" {...storyblokEditable(blok)}>
      <div className="contact">
      <h2 className="text-2xl">{blok.subheadline}</h2>
      <span>{blok.intro}</span>
      <p>{blok.text}</p>
      <p>{blok.text2}</p>
      <p>{blok.text3}</p>
      <span className="form-intro">{blok.formIntro}</span>
        <div id="contactForm"></div>
        <div style={{ display: `${successBox}` }} className="success-box-ct">
          <div>
            <p>Ihre Anfrage wurde erfolgreich an uns gesendet.</p>
            <p>Vielen Dank für Ihre Kontaktaufnahme.</p>
            <button onClick={newSubmit}>Weitere Anfrage stellen</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;